import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateObrasGestaoDeResiduosUseCase } from "../../../presentation/useCases/update/update_obras_gestao_de_residuos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateObrasGestaoDeResiduosUseCase
 */

export class UpdateObrasGestaoDeResiduosUseCase implements IUpdateObrasGestaoDeResiduosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateObrasGestaoDeResiduos(
    idGestaoResiduos?: number | null,
    idObra?: number | null,
    classe?: string | null,
    caracteristica?: string | null,
    tipo?: string | null,
    formaSegregacao?: string | null,
    empresaGerenciadora?: string | null,
    destinacaoFinal?: string | null,
    arquivo?: File | null,
    nomeArquivo?: string | null
  ): Promise<void> {
    await this.repository.putGestaoResiduosUpdate({
      idGestaoResiduos,
      idObra,
      classe,
      caracteristica,
      tipo,
      formaSegregacao,
      empresaGerenciadora,
      destinacaoFinal,
      arquivo: await FileUtils.readFileAsBase64(arquivo),
      nomeArquivo,
    });
  }
}
